import axios from 'axios';

import * as utils from '../utils/utils.js';

// TODO(finnur): Looks like this was intended to possibly trigger a cron job for
// a single event. Maybe we should implement that?
export const runCron = async (event_id) => {
    var url = utils.backendUrl() + `/run_cron`;

    try {
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        return null;
    }
};
